<template>
  <div>
    <b-taglist class="taglist" attached v-if="acuityScoreObject">
      <b-tag type="is-primary" v-tooltip="{ content: time, disabled: isInline }">{{ parseFloat(acuityScoreObject.acuity_score).toFixed(1) }}</b-tag>
      <b-tag type="is-primary is-light" v-if="isInline && time">{{ time }}</b-tag>
    </b-taglist>
    <span v-else>N/A</span>
  </div>
</template>

<script>
export default {
  name: "AcuityScore",
  props: {
    acuityScoreObject: {
      type: Object,
      required: false,
      default: null
    },
    isInline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    time() {
      const updated_at = this.acuityScoreObject?.hour_bin || this.acuityScoreObject?.updated_at
      if (updated_at) {
        return this.$helpers.formatDate(updated_at, 'LT')
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.taglist) {
  &:last-child {
    margin-bottom: 0;
  }
  .tag {
    margin-bottom: 0 !important;
  }
}
</style>